import React from "react";
import { SuccessIcon } from "../icons/SuccessIcon";
import { MultiAssetIcon } from "../icons/MultiAssetIcon";
import { AlertIcon } from "../icons/AlertIcon";
import { OptimalExecutionIcon } from "../icons/OptimalExecutionIcon";
import { StrategyIcon } from "../icons/StrategyIcon";
import { ShieldIcon } from "../icons/ShieldIcon";
import { StockScreenerIcon } from "../icons/StockScreenerIcon";
import { TrialBadgeIcon } from "../icons/TrialBadgeIcon";

const FEATURES = [
  {
    icon: <MultiAssetIcon />,
    title: "Đầu tư đa dạng nhiều tài sản",
    desc: "Cổ phiếu, vàng, trái phiếu, crypto - Nebula tối ưu tất cả trong một danh mục.",
  },
  {
    icon: <AlertIcon />,
    title: "Không bỏ lỡ thời điểm quan trọng",
    desc: "Nebula theo dõi liên tục và cảnh báo ngay khi cần hành động.",
  },
  {
    icon: <OptimalExecutionIcon />,
    title: "Vào lệnh tối ưu, giảm trượt giá",
    desc: "Nebula tự động chia nhỏ lệnh để đạt giá thực hiện tốt hơn.",
  },
  {
    icon: <StrategyIcon />,
    title: "Chiến lược cá nhân hóa cho bạn",
    desc: "Nebula chọn chiến lược đầu tư phù hợp với khẩu vị rủi ro và mục tiêu của bạn.",
  },
  {
    icon: <ShieldIcon />,
    title: "Bảo vệ danh mục trong mọi chu kỳ",
    desc: "Có thể dùng Margin và Hedging bằng VN30 Futures để kiểm soát rủi ro chủ động.",
  },
  {
    icon: <StockScreenerIcon />,
    title: "Chọn cổ phiếu tốt nhất thị trường",
    desc: "Nebula liên tục sàng lọc và cơ cấu danh mục theo từng nhịp thị trường.",
  },
];

const OnboardingWelcome = ({ onNext, onSkip }) => {
  return (
    <div className="flex flex-col items-center w-full max-w-[932px]">
      <div className="w-[64px] h-[64px] mb-[16px] flex items-center justify-center">
        <SuccessIcon />
      </div>

      <h1 className="text-[28px] leading-[36px] font-bold text-[#111827] text-center">
        Chào mừng bạn đến với Nebula!
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-[16px] w-full my-[32px]">
        {FEATURES.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center w-[300px] h-[100px] p-[16px] bg-white border border-[#ececed] rounded-[12px] shrink-0 transition-transform duration-300 ease-out hover:scale-105 cursor-pointer"
          >
            <div className="h-[24px] flex items-center justify-center gap-[4px] mb-[4px]">
              <div className="shrink-0 w-[20px] h-[20px] flex items-center justify-center">
                {feature.icon}
              </div>
              <h3 className="text-[16px] font-medium text-[#111827] leading-[24px] whitespace-nowrap">
                {feature.title}
              </h3>
            </div>
            <p className="text-[14px] text-[#636369] leading-[20px] text-center">
              {feature.desc}
            </p>
          </div>
        ))}
      </div>

      <div className="w-fit bg-[#34d3991a] border border-[#5DDCAD] rounded-[16px] p-[20px_24px] mb-[16px] flex items-center justify-between gap-[24px]">
        <div className="flex-1 text-left">
          <h4 className="text-[18px] font-bold text-[#15543d] leading-[24px] mb-[4px]">
            Bạn được tặng 7 ngày trải nghiệm đầy đủ tính năng!
          </h4>
          <p className="text-[14px] text-[#636369] leading-[20px]">
            Khám phá toàn bộ gói Hội viên MAX hoàn toàn miễn phí.
          </p>
        </div>
        <div className="shrink-0 w-[48px] h-[48px]">
          <TrialBadgeIcon />
        </div>
      </div>

      <p className="text-[14px] text-[#A0A0A5] leading-[20px] text-center max-w-[462px] mb-[32px]">
        Sau 7 ngày, tài khoản tự động chuyển về gói{" "}
        <span className="font-bold text-[#636369]">FREE</span>. Bạn vẫn dùng
        được Nebula, nhưng với tính năng giới hạn hơn.
      </p>

      <div className="w-full flex flex-col items-center gap-[16px]">
        <button
          onClick={onNext}
          className="w-full max-w-[358px] h-[48px] rounded-[12px] bg-[#3c3c43] text-white text-[16px] font-medium transition-all"
        >
          Tạo danh mục cá nhân hóa ngay
        </button>
        <button
          onClick={onSkip}
          className="text-[14px] font-[500] text-[#636369] hover:text-[#111827] transition-colors"
        >
          Tôi không cần cá nhân hóa
        </button>
      </div>
    </div>
  );
};

export default OnboardingWelcome;
